class ScrollbarComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ScrollbarComponentData };
